import { addToListModalStyles } from "@insite/content-library/Components/ManageShareListModal";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";

Object.assign(addToListModalStyles, {
    editingPermissionText: {
        color: COLORS.text.base,
        weight: TYPOGRAPHY.weight.bold,
    },
});
